export default __webpack_public_path__ + "static/media/tpqi.7085e0f8.jpg";